import LocationList from "./LocationList"

const MainContent = ({locations, collapsed = false}) => {
  return (
    <main className="main-content">
      <LocationList locations={locations} collapsed={collapsed}/>
    </main>
  );
};

export default MainContent;
